const sidePaneState = {
    components: 'components',
    focusedComponent: 'focusedComponent',
    componentList: 'componentList',
    conditionals: 'conditionals'
};

const previewPaneState = {
    RECIPE: 'RECIPE',
    EMAIL: 'EMAIL',
    SMS: 'SMS',
    SLACK: 'SLACK',
    DECK: 'DECK'
};

export {
    sidePaneState,
    previewPaneState
};

export const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';

export const DEFAULT_SOURCE_LOCALE_CODE = 'en-US';

export const defaultFonts = 'Inter-UI, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol';

export const mediumOptions = [
    { value: 'DECK', label: 'Deck' },
    { value: 'EMAIL', label: 'Email' }
    // { value: 'SLACK', label: 'Slack' }
];

export const statusOptions = [
    { value: 'SUCCESS', label: 'Success' },
    { value: 'FAILED', label: 'Failed' }
];